import React from "react";

const Checkout = () => {
    return <div>CheckOut Page</div>;
};

export default Checkout;
